"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageDropzoneBase = exports.ImageDropzone = void 0;
var _lodestarUtils = require("@smartsheet/lodestar-utils");
var _react = _interopRequireWildcard(require("react"));
var _i18n = require("../../../i18n/i18n");
var _useTheme = require("../../../theme/utils/useTheme");
var _typography = require("../../typography");
var _DropzoneStyled = require("../styled/DropzoneStyled");
var _InvalidDropzoneHoverBoxStyled = require("../styled/InvalidDropzoneHoverBoxStyled");
var _ValidDropzoneHoverBoxStyled = require("../styled/ValidDropzoneHoverBoxStyled");
var _imageUploaderTheme = require("../styled/imageUploaderTheme");
var _ImageUploaderIcon = require("./ImageUploaderIcon");
const ImageDropzoneBase = _ref => {
  let {
    acceptableMimeTypes,
    children,
    clientId,
    height,
    i18n,
    isDisabled,
    onDrop,
    usageType
  } = _ref;
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  const [draggingState, setDraggingState] = (0, _react.useState)({
    isDragging: false,
    isValidFileType: false
  });
  const checkIfValidFileType = item => {
    return item.kind === "file" && acceptableMimeTypes.includes(item.type);
  };
  const handleDragEnter = e => {
    if (isDisabled) return;
    const draggingItem = e.dataTransfer?.items?.[0];
    if (!draggingItem || draggingItem.kind !== "file") return;
    e.preventDefault();
    e.stopPropagation();
    setDraggingState({
      isDragging: true,
      isValidFileType: checkIfValidFileType(draggingItem)
    });
  };
  const handleDragLeave = e => {
    if (isDisabled) return;
    e.preventDefault();
    e.stopPropagation();
    setDraggingState({
      isDragging: false,
      isValidFileType: false
    });
  };
  const handleDrag = e => {
    if (isDisabled) return;
    e.preventDefault();
    e.stopPropagation();
  };
  const handleDrop = e => {
    if (isDisabled) return;
    const file = e.dataTransfer?.files?.[0];
    if (!file) return;
    e.preventDefault();
    e.stopPropagation();
    onDrop(file);
    setDraggingState({
      isDragging: false,
      isValidFileType: false
    });
    e.dataTransfer.clearData();
  };
  return /*#__PURE__*/_react.default.createElement(_DropzoneStyled.DropzoneStyled, {
    "aria-disabled": isDisabled,
    "data-client-id": clientId,
    height: height,
    onDragEnter: handleDragEnter,
    onDragLeave: handleDragLeave,
    onDragOver: handleDrag,
    onDrop: handleDrop
  }, draggingState.isDragging && draggingState.isValidFileType && /*#__PURE__*/_react.default.createElement(_ValidDropzoneHoverBoxStyled.ValidDropzoneHoverBoxStyled, {
    themeMode: themeMode
  }, usageType === "image" && themeMode.includes("ursa") && /*#__PURE__*/_react.default.createElement(_ImageUploaderIcon.ImageUploaderIcon, {
    themeMode: themeMode
  }), /*#__PURE__*/_react.default.createElement(_typography.TypeRampV2
  // @ts-expect-error TODO: update typerampv2 to take themeMode directly
  , {
    system: themeMode.split("-")[0],
    variant: _imageUploaderTheme.imageUploaderTheme.dropSpan.hoverVariant(themeMode),
    style: {
      color: _imageUploaderTheme.imageUploaderTheme.textColor.validHover(themeMode)
    }
  }, usageType === "image" && i18n._( /*i18n*/"Drop your image here"), usageType === "logo" && i18n._( /*i18n*/"Drop your logo here"))), draggingState.isDragging && !draggingState.isValidFileType && /*#__PURE__*/_react.default.createElement(_InvalidDropzoneHoverBoxStyled.InvalidDropzoneHoverBoxStyled, {
    "data-client-id": (0, _lodestarUtils.getClientId)(clientId, "invalid-file-error"),
    themeMode: themeMode
  }, usageType === "image" && themeMode.includes("ursa") && /*#__PURE__*/_react.default.createElement(_ImageUploaderIcon.ImageUploaderIcon, {
    themeMode: themeMode,
    isInvalid: true
  }), /*#__PURE__*/_react.default.createElement(_typography.TypeRampV2
  // @ts-expect-error TODO: update typerampv2 to take themeMode directly
  , {
    system: themeMode.split("-")[0],
    variant: _imageUploaderTheme.imageUploaderTheme.dropSpan.hoverVariant(themeMode),
    style: {
      color: _imageUploaderTheme.imageUploaderTheme.textColor.invalid(themeMode)
    }
  }, i18n._( /*i18n*/"Unsupported file type"))), !draggingState.isDragging && children);
};
exports.ImageDropzoneBase = ImageDropzoneBase;
const ImageDropzone = (0, _i18n.withI18n)(ImageDropzoneBase);
exports.ImageDropzone = ImageDropzone;
//# sourceMappingURL=ImageDropzone.js.map